module.exports = __webpack_public_path__ + "static/img/shcygn3.c47226b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn3.png
// module id = 373
// module chunks = 0